$(document).ready(function () {

  wishlists = localStorage.getItem('wishlist') ? localStorage.getItem('wishlist').split(',') : [];
  wishlists.forEach(function (handle) {
    $('.wishlist[data-handle="' + handle + '"]').addClass('active')
  })

  $('.wishlist').on('click', function () {
    var span = $(this).find('span'), handle = $(this).attr('data-handle')
    if ($(this).is('.active')) {
      $(this).removeClass('active')
      span.text('Removed from favorites').addClass('show')
      wishlists.splice(wishlists.indexOf(handle), 1)
    } else {
      $(this).addClass('active')
      span.text('Added to favorites').addClass('show')
      wishlists.push(handle)
    }

    localStorage.setItem('wishlist', wishlists.join(','))

    setTimeout(function () {
      span.removeClass('show')
    }, 2000)
    return false
  })

  var interval = null
  if ($('#customer_login').length) {
    interval = setInterval(function () {
      if ($('#customer_login [name="return_url"]').length) {
        clearInterval(interval)
        if (location.search.indexOf('portal') > -1) {
          $('#customer_login [name="return_url"]').val('/pages/portal')
        } else {
          $('#customer_login [name="return_url"]').val('/collections/all')
        }
      }
    }, 500)
  }

  $('.QRCODE').on('click', function () {
    $('#QRCODE_POPUP').addClass('active')
    return false
  })
  $('#QRCODE_POPUP .bg, #QRCODE_POPUP .close').on('click', function () {
    $('#QRCODE_POPUP').removeClass('active')
    return false
  })

  if ($('.navtabs').length) {
    $(".navtabs:not(.fixed)").sticky({ topSpacing: 0 });
  }


  $('#shopify-section-template--15885507657982__1648916212aa3ac5cc .btn').on('click', function () {
    $("html, body").animate({ scrollTop: $('#shopify-section-{{ section.id }}').offset().top }, 600);
    return false
  })

  if ($('#areaslider').length) {
    var slider = tns({
      container: '#areaslider',
      items: 1,
      mode: 'gallery',
      controls: false,
      nav: false,
      autoHeight: true,
      touch: false,
      loop: false
    });

    $('body').on('click', '.area-link', function () {
      if ($(this).attr('data-href')) {
        location.href = $(this).attr('data-href')
      } else {
        slideI = $(this).attr('data-go')
        index = $('[data-i="' + slideI + '"]').attr('data-index')
        slider.goTo(parseInt(index))

        $("#areaslider").get(0).scrollIntoView()
      }

      return false
    })
  }

  if ($('.featured-slider').length) {

    $('.featured-slider').each(function (i) {

      $(this).find('.slider').each(function () {
        var slider = tns({
          container: $(this)[0]
        })
      })

      $(this).slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        autoplay: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      })


      /*var _this = $(this)
      tns({
        container: _this[0],
        items: 1,
        controls: false,
        nav: true,
        navPosition: 'bottom',
        autoplay: false,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        responsive: {
          480: {
            items: 2
          },
          768: {
            items: 3
          },
          1200: {
            items: 4
          }
        },
          nested: 'outer'
      });
      _this.find('.slider').each(function() {
        var slider = tns({
          container: $(this)[0],
          nested: 'inner'
        })
      })*/

    })
  }

  $('.cssslider').swipe({
    swipeLeft: function (e, dir) {
      parent = $(this)
      var name = parent.find('input:checked').attr('id')
      dot = parent.find('.cssslider_dots [for="' + name + '"]')
      if (dot.next().length) {
        dot.next().click()
      } else {
        parent.find('.cssslider_dots label:first-child').click()
      }
    },
    swipeRight: function (e, dir) {
      parent = $(this)
      var name = parent.find('input:checked').attr('id')
      dot = parent.find('.cssslider_dots [for="' + name + '"]')
      if (dot.prev().length) {
        dot.prev().click()
      } else {
        parent.find('.cssslider_dots label:last-child').click()
      }
    },
    threshold: 20
  })

  $(document).on('click', function (e) {
    if (!$(e.target).parents('.search-areas form').length) {
      $('.search-areas form').removeClass('open')
    }
  })

  count = 0;
  type = 'H'

  $('.search-areas.general form input').on('click focus', function () {
    $('body, html').animate({
      scrollTop: $('.search-areas.general form').offset().top - 50
    }, 500)
  })

  $('.search-areas.general form').on('submit', function (e) {
    e.preventDefault()
    if (count) {
      val = $(this).find('input').val().trim()
      ga('send', 'event', 'Search', (type == 'H' ? 'Hidden Gems' : 'Xperiences'), 'Form', val, { 'nonInteration': false });
      setTimeout(function () {
        location.href = '/collections/search?q=' + val + '&type=' + (type ? type : 'H')
      }, 100)
    }
  })

  $('.search-areas.clean form').on('submit', function (e) {
    e.preventDefault()
    var urlParams = new URLSearchParams(window.location.search);
    var t = urlParams.get('type');
    val = $(this).find('input').val().trim()
    ga('send', 'event', 'Search', (type == 'H' ? 'Hidden Gems' : 'Xperiences'), 'Form', val, { 'nonInteration': false });
    setTimeout(function () {
      location.href = '/collections/search?q=' + val + '&type=' + (t ? t : 'H')
    }, 100)
  })

  $('.search-areas.general .tabs > span').on('click', function () {
    if (!$(this).is('.active')) {
      $('.search-areas.general .tabs > span, .search-areas.general form .results .inside').removeClass('active')
      $(this).addClass('active')
      type = $(this).data('tab')
      $('.search-areas.general form .results .inside[data-tab="' + type + '"]').addClass('active')

      if (type == 'H') {
        $('.search-areas form .results .btn').text('Show All Hidden Gems')
      } else {
        $('.search-areas form .results .btn').text('Show All Xperiences™')
      }
      $('.search-areas form .results .btn').attr('href', '/collections/search?q=' + $('.search-areas.general form input').val().toLowerCase().trim() + '&type=' + type)

      parent = $('.search-areas.general form')
      if (count[type]) {
        parent.find('.results > h5').addClass('hide')
        parent.find('.results > .btn').removeClass('hide')
      } else {
        parent.find('.results > .btn').addClass('hide')
        parent.find('.results > h5').removeClass('hide')
      }
    }
    return false
  })

  $('.search-areas.general form input').on('focus', function () {
    var val = $(this).val().toLowerCase().trim(), parent = $(this).parents('form')

    if (val == '') {
      parent.removeClass('open')
    } else {
      parent.find('.results .inside').html('')

      count = {
        H: 0,
        X: 0
      };
      xproducts.forEach(function (p) {
        if (p.location.toLowerCase().indexOf(val) > -1 || p.title.toLowerCase().indexOf(val) > -1 || p.tags.toLowerCase().indexOf(val) > -1 || p.address.toLowerCase().indexOf(val) > -1) {
          var html = xtmpl
          count[p.type]++
          Object.keys(p).forEach(function (key) {
            html = html.replace('{' + key + '}', p[key])
          })
          parent.find('.results .inside[data-tab="' + p.type + '"]').append(html)
        }
      })

      $('.search-areas .tabs [data-tab="H"] span').text(count.H)
      $('.search-areas .tabs [data-tab="X"] span').text(count.X)

      parent.addClass('open')

      if (count.H > 0 && count.X > 0) {
        $('.search-areas .tabs ').removeClass('one none')
      } else {
        $('.search-areas .tabs ').addClass('none')
      }

      if (count.H > 0) {
        $('.search-areas .tabs [data-tab="H"]').show()
        $('.search-areas .tabs ').removeClass('none')
      }
      if (count.X > 0) {
        $('.search-areas .tabs [data-tab="X"]').show()
        $('.search-areas .tabs ').removeClass('none')
      }

      if (count[type]) {
        parent.find('.results > h5').addClass('hide')
        parent.find('.results > .btn').removeClass('hide').attr('href', '/collections/search?q=' + val + '&type=' + type)
      } else {
        parent.find('.results > .btn').addClass('hide')
        parent.find('.results > h5').removeClass('hide')

        if (type == 'H') {
          if (count.X > 0) {
            $('.search-areas .tabs [data-tab="H"]').hide()
            $('.search-areas .tabs [data-tab="X"]').click()
            $('.search-areas .tabs ').addClass('one')
          }
        }

        if (type == 'X') {
          if (count.H > 0) {
            $('.search-areas .tabs [data-tab="X"]').hide()
            $('.search-areas .tabs [data-tab="H"]').click()
          }
        }
      }

    }

  })

  var debounce

  $('.search-areas.general form input').on('input', function () {
    var self = $(this);
    clearInterval(debounce);
    debounce = setTimeout(function () {
      var val = self.val().toLowerCase().trim(), parent = self.parents('form')

      if (val == '') {
        parent.removeClass('open')
      } else {
        parent.find('.results .inside').html('')

        count = {
          H: 0,
          X: 0
        };
        xproducts.forEach(function (p) {
          if (p.location.toLowerCase().indexOf(val) > -1 || p.title.toLowerCase().indexOf(val) > -1 || p.tags.toLowerCase().indexOf(val) > -1 || p.address.toLowerCase().indexOf(val) > -1) {
            var html = xtmpl
            count[p.type]++
            Object.keys(p).forEach(function (key) {
              html = html.replace('{' + key + '}', p[key])
            })
            parent.find('.results .inside[data-tab="' + p.type + '"]').append(html)
          }
        })

        $('.search-areas .tabs [data-tab="H"] span').text(count.H)
        $('.search-areas .tabs [data-tab="X"] span').text(count.X)

        parent.addClass('open')

        if (count.H > 0 && count.X > 0) {
          $('.search-areas .tabs ').removeClass('one none')
        } else {
          $('.search-areas .tabs ').addClass('none')
        }

        if (count.H > 0) {
          $('.search-areas .tabs [data-tab="H"]').show()
          $('.search-areas .tabs ').removeClass('none')
        }
        if (count.X > 0) {
          $('.search-areas .tabs [data-tab="X"]').show()
          $('.search-areas .tabs ').removeClass('none')
        }

        if (count[type]) {
          parent.find('.results > h5').addClass('hide')
          parent.find('.results > .btn').removeClass('hide').attr('href', '/collections/search?q=' + val + '&type=' + type)
        } else {
          parent.find('.results > .btn').addClass('hide')
          parent.find('.results > h5').removeClass('hide')

          if (type == 'H') {
            if (count.X > 0) {
              $('.search-areas .tabs [data-tab="H"]').hide()
              $('.search-areas .tabs [data-tab="X"]').click()
              $('.search-areas .tabs ').addClass('one')
            }
          }

          if (type == 'X') {
            if (count.H > 0) {
              $('.search-areas .tabs [data-tab="X"]').hide()
              $('.search-areas .tabs [data-tab="H"]').click()
            }
          }
        }

      }
    }, 500)
  })

  $('.search-areas .results > .btn').on('click', function () {
    $(this).parents('form').submit()
    return false
  })

  $('.video-parent-section.hero').on('click', function (e) {
    if (e.target.nodeName != 'A') {
      var sound = $(this).find('.sound')
      if (sound.length && $(this).find('iframe').length == 0) {
        if (sound.is('.on')) {
          sound.removeClass('on')
          $(this).find('video').prop('muted', true);
          $(this).find('video').prop('controls', false);
        } else {
          sound.addClass('on')
          $(this).find('video').prop('muted', false);
          $(this).find('video').prop('controls', true);
        }
      }
    }
  })

  /*$('[href^="#shopify"]').on('click', function() {
    $('html,body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 200)
    return false
  })*/

  $('#app .item .cssslider_nav').on('click', function (e) {
    if (e.target.className == 'cssslider_nav') {
      location.href = $(this).parents('.item').find('a').attr('href')
    }
  })

  $("#product-backbutton").on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/pages/xplore"
    }
  })

})

function loadFile(e, file) {
  allow = true
  input = $('[name="' + file + '"]')
  label = $('[for="' + file + '"]')

  form = input.parent()[0]
  data = new FormData(form)
  data.append('module', 'pass')
  data.append('action', 'photo')

  $('input[name="' + file + '"]').each(function (i) {
    if (typeof this.files[0] !== 'undefined') {
      size = this.files[0].size;
      if (size > 5242880) {
        allow = false
        alert(this.files[0].name + ' weighs more than 5MB')
      }
    }
  })

  if (allow) {
    label.addClass('loads')

    $.ajax({
      method: 'post',
      url: 'https://master.minionmade.net/forms?shop=xplorerpass.myshopify.com',
      enctype: 'multipart/form-data',
      processData: false,  // Important!
      contentType: false,
      cache: false,
      data: data,
      success: function (res) {
        input.parent().next().css('background-image', 'url(' + res.url + ')');
        label.removeClass('loads')
      },
      error: function (res) {
        label.removeClass('loads')
        alert(res.message)
      }
    })

  }
}

$(window).on('scroll', function () {
  var top = $(window).scrollTop()

  // This is for Xperience list
  if (top > $('.filters-wrapper').offset()?.top - 50) {
    $('.filters-wrapper').addClass('fixing')
    $('.section-header').addClass('fixing')
  } else {
    $('.filters-wrapper').removeClass('fixing')
    $('.section-header').removeClass('fixing')
  }

  // This is for Hidden Gems
  if (top > $('.search-areas.general').offset()?.top + 50) {
    $('.search-areas.general').addClass('fixing')
  } else {
    $('.search-areas.general').removeClass('fixing')
  }
})